import { render } from "./App.vue?vue&type=template&id=3d53b6c1"
const script = {}

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/base/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d53b6c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d53b6c1', __exports__)) {
    api.reload('3d53b6c1', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=3d53b6c1", () => {
    api.rerender('3d53b6c1', render)
  })

}


export default __exports__